import { OutagesFiltersI } from '@/types';
import { useState } from 'react';

const initialFilters = {
  siteId: null,
  startDate: null,
  endDate: null,
  query: '',
};

interface UseOutagesFiltersOptions {
  initialFilters?: Partial<OutagesFiltersI>;
}

const getInitialFilters = (
  overrides?: Partial<OutagesFiltersI>,
): OutagesFiltersI => ({
  ...initialFilters,
  ...overrides,
});

export const useOutagesFilters = ({
  initialFilters: initialFiltersOverrides,
}: UseOutagesFiltersOptions = {}) => {
  const [outagesFilters, setOutagesFilters] = useState<OutagesFiltersI>(
    getInitialFilters(initialFiltersOverrides),
  );

  const updateFilters = (filters: Partial<OutagesFiltersI>) => {
    setOutagesFilters((prevState) => ({ ...prevState, ...filters }));
  };

  const resetFilters = () => {
    setOutagesFilters(getInitialFilters(initialFiltersOverrides));
  };

  return {
    outagesFilters,
    resetFilters,
    updateFilters,
  };
};
